import rootEpic from 'Epics';
import thunk from 'redux-thunk';
import { history } from '../router/history';
import { createLogger } from 'redux-logger';
import createRootReducer from '../../../reducers';
import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware } from 'connected-react-router';
import callAPIMiddleware from 'Middleware/callAPIMiddleware';
import { composeWithDevTools } from 'redux-devtools-extension';

const routingMiddleware = routerMiddleware(history);
const epicMiddleware = createEpicMiddleware();
const loggerMiddleware = createLogger();

export default function configureStore(preloadedState) {
  const middleware = [
    thunk,
    callAPIMiddleware,
    routingMiddleware,
    epicMiddleware,
    loggerMiddleware,
  ];

  const store = createStore(
    createRootReducer(history),
    preloadedState,
    composeWithDevTools(applyMiddleware(...middleware))
  );

  epicMiddleware.run(rootEpic);

  return store;
}
